import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseNewspaperFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 5.25C3.5 4.2835 4.2835 3.5 5.25 3.5H21.75C22.7165 3.5 23.5 4.2835 23.5 5.25V17.75C23.5 19.2688 22.2688 20.5 20.75 20.5H2.75C1.50736 20.5 0.5 19.4926 0.5 18.25V6.25C0.5 5.83579 0.835786 5.5 1.25 5.5C1.66421 5.5 2 5.83579 2 6.25V18.25C2 18.6642 2.33579 19 2.75 19C3.16421 19 3.5 18.6642 3.5 18.25V5.25ZM8.5 8.5V11.5H11.5V8.5H8.5ZM8 7C7.44772 7 7 7.44772 7 8V12C7 12.5523 7.44772 13 8 13H12C12.5523 13 13 12.5523 13 12V8C13 7.44772 12.5523 7 12 7H8ZM14.75 8C14.75 7.58579 15.0858 7.25 15.5 7.25H19C19.4142 7.25 19.75 7.58579 19.75 8C19.75 8.41421 19.4142 8.75 19 8.75H15.5C15.0858 8.75 14.75 8.41421 14.75 8ZM15.5 11.25C15.0858 11.25 14.75 11.5858 14.75 12C14.75 12.4142 15.0858 12.75 15.5 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H15.5ZM7.25 16C7.25 15.5858 7.58579 15.25 8 15.25H19C19.4142 15.25 19.75 15.5858 19.75 16C19.75 16.4142 19.4142 16.75 19 16.75H8C7.58579 16.75 7.25 16.4142 7.25 16Z"
        fill={color}
      />
    </svg>
  );
};
